<script setup lang="ts">
const {
  errorMessages = [],
  readonly = false,
  disabled = false,
  hideDetails = undefined,
  label = '',
  placeholder = '',
  rounded = 'lg',
  bgColor = 'white',
  prefix = '',
  suffix = '',
  prefixIcon = '',
  suffixIcon = '',
  required = false,
  type = 'text',
  persistentPlaceholder = false,
  density = 'default',
  singleLine = false,
} = defineProps<{
  errorMessages?: string | string[];
  readonly?: boolean;
  disabled?: boolean;
  hideDetails?: boolean | 'auto';
  label?: string;
  rounded?: string | number | boolean;
  placeholder?: string;
  bgColor?: string;
  prefix?: string;
  suffix?: string;
  prefixIcon?: string;
  prefixIconCustom?: string;
  suffixIcon?: string;
  required?: boolean;
  type?: string;
  persistentPlaceholder?: boolean;
  density?: 'default' | 'comfortable' | 'compact';
  singleLine?: boolean;
}>();

const text = defineModel<string | number | null>();
</script>
<template>
  <v-text-field
    v-model="text"
    variant="solo"
    :type="type"
    :hide-details="hideDetails"
    :error-messages="errorMessages"
    :placeholder="placeholder"
    :readonly="readonly"
    :disabled="disabled"
    :rounded="rounded"
    :bg-color="bgColor"
    :prefix="prefix"
    :suffix="suffix"
    data-testid="text-field"
    :persistent-placeholder="persistentPlaceholder"
    :density="density"
    :single-line="singleLine"
  >
    <template #label> {{ label }}<span v-if="required" class="text-error"> *</span> </template>
    <template #prepend-inner>
      <slot name="prepend-inner">
        <v-icon v-if="prefixIcon" :icon="prefixIcon" />
        <v-img v-if="prefixIconCustom" :src="prefixIconCustom" height="24" width="24" />
      </slot>
    </template>
    <template #append-inner>
      <slot name="append-inner">
        <v-icon v-if="suffixIcon" :icon="suffixIcon" />
      </slot>
    </template>
  </v-text-field>
</template>

<style scoped>
:deep(.v-label) {
  color: #414156 !important;
  opacity: 1 !important;
}

:deep(.v-input__control) {
  overflow: visible;
}

:deep(.v-field) {
  border: 1px solid rgba(var(--v-border-color), var(--v-border-opacity));
  box-shadow: none !important;
  overflow: visible;
  background-color: #ffffff !important;
}

:deep(.v-field--focused) {
  border-color: #414156 !important;
  background-color: #fffce9 !important;
}

:deep(.v-field--error) {
  border-color: rgb(var(--v-theme-error)) !important;
}

:deep(.v-field--error .v-field__outline),
:deep(.v-field__outline) {
  display: none;
}

:deep(.v-field__overlay) {
  display: none;
}
</style>
